import React from "react";

export default function ServiceCard({ title, description, icon }) {
  return (
    <div className="col-md-4 mb-4">
      <div className="card h-100 shadow-sm border-0">
        <div className="card-body text-center">
          <div className="mb-3">
            <i className={`bi ${icon} fs-1 text-primary`} />
          </div>
          <h5 className="fw-bold">{title}</h5>
          <p className="text-muted">{description}</p>
        </div>
      </div>
    </div>
  );
}